// src/components/GroupInviteList.js
import React, { useState } from 'react';
import { apiJson } from '../lib/api';

export default function GroupInviteList({ invitations }) {
  const [membershipCounts, setMembershipCounts] = useState({});

  const handleCountChange = (groupId, value) => {
    setMembershipCounts(prev => ({
      ...prev,
      [groupId]: parseInt(value || '1')
    }));
  };

  const handleJoin = async (groupId) => {
    const requestedMemberships = membershipCounts[groupId] || 1;

    let user = null;
    try {
      user = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || 'null');
    } catch {}
    if (!user?.id) {
      alert('❌ You must be logged in to request a join');
      return;
    }

    try {
      const res = await apiJson(`/api/invitations/request`, {
        method: 'POST',
        body: {
          user_id: user.id,
          group_id: groupId,
          requested_memberships: requestedMemberships,
        },
      });

      if (res.ok) {
        alert(`✅ Request sent for ${requestedMemberships} membership(s)`);
      } else {
        alert(res.data?.error || '❌ Error sending request');
      }
    } catch (err) {
      alert('❌ Failed to send request: ' + (err?.message || 'Unknown error'));
    }
  };

  return (
    <div className="card">
      <h3>Groups You Can Join</h3>
      <ul>
        {invitations.map(group => (
          <li key={group.groupId}>
            {group.groupName}
            <br />
            <label>
              Memberships:
              <input
                type="number"
                min="1"
                value={membershipCounts[group.groupId] || 1}
                onChange={(e) => handleCountChange(group.groupId, e.target.value)}
                style={{ marginLeft: '10px', width: '60px' }}
              />
            </label>
            <button style={{ marginLeft: '10px' }} onClick={() => handleJoin(group.groupId)}>
              Request to Join
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
